import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { NotificationService } from 'src/app/services/interceptor/notification';
import { ToastrService } from 'ngx-toastr';
import { CustomhtmlsanitizerPipe } from 'src/app/pipes/customhtmlsanitizer.pipe';
import { AdminAction } from 'src/app/models/adminaction.model';
import { UtilService } from 'src/app/services/util.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';

declare const $: any;

@Component({
  selector: 'app-assessmentdetails',
  templateUrl: './assessmentdetails.component.html',
  styleUrls: ['./assessmentdetails.component.css'],
})
export class AssessmentdetailsComponent implements OnInit {
  assessment: any = {};
  assessmentname: string;
  assessmentID: number;
  confirmAssessmentdelete = false;
  confirmQuestiondelete = false;
  errormessage: string;
  classID: number;
  batchID: number;
  loading: string;
  fetching = true;

  adminActions: AdminAction[] = [];
  crumbitem: any;

  questions: any = [];
  questionType: string;
  startTime: string;
  endTime: String;
  timedType: string;
  classFileName: string;

  constructor(
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private assessmentManager: AssessmentmanagerService,
    public sanitizer: DomSanitizer,
    public header: ComponentheaderService,
    private notification: NotificationService,
    private util: UtilService
  ) {
    this.assessmentname = 'Loading Assessment...';
    this.header.setHeaderDisplay('Assessment Details', [], []);
  }

  async ngOnInit() {
    //debugger;
    this.header.pageLoadingStarted(this);
    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    this.batchID = this.activatedroute.snapshot.queryParams.batchid;
    this.notification.currentNotificationType =
      this.notification.CALL_TYPE.SIMPLE_PAGE_LOAD_GET_CONTENT;
    let response: any = await this.assessmentManager
      .getAssessmentDetails(this.assessmentID, this.batchID)
      .toPromise()
      .catch(() => {
        this.router.navigate(['/user/assessmentconsole'], {
          queryParams: { classid: this.classID, batchid: this.batchID },
        });
      });

    if (!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)) {
      if (response.isadmin) {
        this.util.notifyFeatureNotAvailable(FeatureGroups.ASSESSMENTS);
      }
      this.header.pageLoadingDone(this);
      this.router.navigate(['/user/lesson'], { queryParams: { classid: this.classID } });
      return;
    }
    this.assessment = response.data;
    this.timedType = this.assessment.timedType;
    this.startTime = this.assessment.startTime;
    this.questionType = this.assessment.questionType;
    this.endTime = this.assessment.endTime;
    this.questions = this.assessment.questions;

    this.assessmentname = response.data.name;
    this.crumbitem = response.breadcrumb;
    if (response.data.aflag != 200) {
      //redirect to student view
      this.router.navigate(['user/studentassesment'], {
        queryParams: {
          aid: this.assessmentID,
          classid: this.classID,
          batchid: this.batchID,
          target: this.assessmentManager.bufferRoute.Details,
        },
      });
    }

    this.fetching = false;

    if (response.isadmin) {
      this.adminActions = [
        // user/editassessment?classid=83&aid=117&target=4&activity=2
        ///user/assessmentsubmissions?aid=117
        {
          displaytext: 'Edit Assessment',
          route: '/user/editassessment',
          params: {
            classid: this.classID,
            aid: this.assessmentID,
            activity: this.assessmentManager.activityType.Edit,
          },
          classes: ['fas', 'fa-edit'],
        },
        {
          displaytext: 'View Submissions',
          route: '/user/assessmentsubmissions',
          params: {
            classid: this.classID,
            aid: this.assessmentID,
            batchid: this.batchID,
          },
          classes: ['fas', 'fa-mail-bulk'],
        },
        {
          displaytext: 'View Marksheet',
          route: '/user/assessmentmarksheet',
          params: {
            classid: this.classID,
            aid: this.assessmentID,
            batchid: this.batchID,
          },
          classes: ['fas', 'fa-check-double'],
        },
        {
          displaytext: 'Delete Assessment',
          callback: this.popconfirmdelete.bind(this),
          classes: ['fas', 'fa-trash'],
        },
      ];
      if (this.questionType == 'MultipleChoice') {
        let upload = {
          displaytext: 'Upload Questions',
          callback: this.uploadbatchquestionshow.bind(this),
          classes: ['fas', 'fa-upload'],
        };
        this.adminActions.push(upload);
      }
    }

    // this.header.setHeaderDisplay("Assessments",
    // [{ displaytext: 'Home', route: '/user' },
    // { displaytext: "Lesson", route: `/user/lesson`, params: { classid: this.classID } },
    // { displaytext: "Assessments", route: `/user/assessmentconsole`, params: { classid: this.classID,batchid: this.batchID } },
    // { displaytext: this.assessmentname, route: `/user/assessmentdetails`, params: { classid: this.classID,batchid: this.batchID,aid : this.assessmentID } }
    // ],
    // this.adminActions);

    this.header.setHeaderDisplay(
      `Assessment : ${this.crumbitem.assessmentName}`,
      [
        { displaytext:  'School', route: `/user/schoolhome`, params: { schoolID: this.crumbitem.schoolID } },
        { displaytext:  'Course', route: `/user/moduledetails`, params: { moduleID: this.crumbitem.moduleID } },
        { displaytext: 'Lesson', route: `/user/lesson`, params: { classid: this.classID } },
        { displaytext: "Assessments", route: `/user/assessmentconsole`, params: { classid: this.classID, batchid: this.batchID } },
        { displaytext: this.crumbitem.assessmentName, route: `/user/assessmentdetails`, params: { classid: this.classID, batchid: this.batchID, aid: this.assessmentID } }
      ],
      this.adminActions
    );

    localStorage.setItem(
      this.assessmentManager.LocalStorage_FLAG.questionType,
      this.assessment.questionType
    );
    localStorage.setItem(
      this.assessmentManager.LocalStorage_FLAG.AssesmentTitle,
      this.assessment.name
    );
    localStorage.setItem(
      this.assessmentManager.LocalStorage_FLAG.deliveryType,
      response.data.timedType
    );
    localStorage.setItem(
      this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache,
      JSON.stringify(response.data)
    );

    $('.questionList').on('click', '.deleteQuestion', function () {
      $(this).parent().parent().parent().find('.confirmPane').show();
      $(this).parent().parent().hide();
    });

    $('.questionList').on('click', '.undodelete', function () {
      $(this).parent().parent().hide();
      $(this).parent().parent().parent().find('.mainbtn').show();
    });

    this.header.pageLoadingDone(this);
  }

  openAddQuestion() {
    this.router.navigate(['/user/addquestion'], {
      queryParams: {
        aid: this.assessmentID,
        batchid: this.batchID,
        classid: this.classID,
        target: this.assessmentManager.bufferRoute.AddQuestion,
      },
    });
  }

  reorder(questionID: number, direction: number) {
    direction == 1
      ? this.toastr.info('Moving Question Down')
      : this.toastr.info('Moving Question Up');

    this.assessmentManager
      .getReorderedQuestions(questionID, direction)
      .toPromise()
      .then((Response: any) => {
        this.questions = Response.data.questions;
        this.toastr.success('Question Moved');
      });
  }

  popconfirmdelete(flag: number) {
    // if(flag == 1){
    //   this.confirmAssessmentdelete = true;
    // }else{
    //   this.confirmAssessmentdelete = false;
    // }
    $('#deleteCourse').modal('show');
  }

  uploadbatchquestionshow() {
    $('#uploadbatchquestion').modal('show');
  }

  confirmDelete() {
    this.loading = 'Deleting Assessment, please wait...';
    this.errormessage = null;
    this.confirmAssessmentdelete = false;
    this.assessmentManager.deleteAssessment(this.assessmentID).subscribe(
      (data: any) => {
        //redirect to the assessment home
        this.router.navigate(['/user/assessmentconsole'], {
          queryParams: {
            classid: this.classID,
            batchid: this.batchID,
            target: this.assessmentManager.bufferRoute.AssessmentConsole,
          },
        });
      },
      (err: HttpErrorResponse) => {
        this.loading = null;
        this.toastr.error(
          'Error encountered while attempting to delete assessment'
        );
      }
    );
  }
  async uploadquestions(
    files: FileList,
    fileencoding: any,
    format: any,
    negmarking: any,
    raw: any
  ) {
    this.header.pageLoadingStarted(this);

    // `return` inside the .catch callback returned from the callback, not from this method, so a
    // failed upload carried on with `message` undefined and threw a TypeError on the next line —
    // after showing the error. try/catch so a failure actually stops here.
    try {
      const message: any = await this.assessmentManager
        .uploadquestionfile(
          this.assessmentID,
          fileencoding,
          format,
          raw,
          negmarking,
          files
        )
        .toPromise();

      this.toastr.success(message?.message, 'File Uploaded Successfully');
      // Reload so the new questions appear. Worth replacing with a refetch, but the question list
      // is built during load here and pulling that apart is more than this fix needs.
      window.location.reload();
    } catch (err) {
      this.toastr.error(err?.error?.message || 'Unable to upload the questions');
    } finally {
      this.header.pageLoadingDone(this);
    }
  }

  deleteQuestion(qid: number) {
    this.assessmentManager
      .deleteQuestion(qid, this.batchID)
      .subscribe((data: any) => {
        this.toastr.success('Question deleted');
        this.router.navigate(['/buffer'], {
          queryParams: {
            aid: this.assessmentID,
            classid: this.classID,
            target: this.assessmentManager.bufferRoute.Details,
            batchid: this.batchID
          },
        });
      });
  }

  showEditAssessmentForm() {
    this.router.navigate(['/user/editassessment'], {
      queryParams: {
        classid: this.classID,
        aid: this.assessmentID,
        target: this.assessmentManager.bufferRoute.EditAssessment,
        activity: this.assessmentManager.activityType.Edit,
      },
    });
  }

  showAssessments() {
    this.router.navigate(['/user/assessmentconsole'], {
      queryParams: { classid: this.classID, batchid: this.batchID },
    });
  }

  // onSubmitUploadQuestionsForm(){
  //   uploadquestions(this.files.files,fileenccoding.value,format.value,negmarking.checked,raw.checked)
  // }
}
